import config from 'react-global-configuration';

config.set({
     EndPointPath: process.env.REACT_APP_ENDPOINT_PATH,
    HashingEndPointPath: process.env.REACT_APP_HASHING_ENDPOINT_PATH,
    SocketConnectionPort: process.env.REACT_APP_SOCKET_CONNECTION_PORT,

    DemoMode: process.env.REACT_APP_DEMO_MODE === 'true',
    AWS_UPLOAD: process.env.REACT_APP_AWS_UPLOAD === 'true',

    API_KEY: process.env.REACT_APP_API_KEY, 

    BetaMode: process.env.REACT_APP_BETA_MODE === 'true'
});